export default __webpack_public_path__ + "static/media/setup-portal.ce8f8e8a.jpg";